import { useFooter, useHeader } from 'region-frame';

interface useRegionFrameParams {
  type: string;
  headerLocals?: any;
  footerLocals?: any;
  footerTheme?: string;
}

let componentHeader = null;
let componentFooter = null;
export async function useRegionFrame(
  params?: useRegionFrameParams
): Promise<any> {
  const { type, footerTheme } = params || {};
  const { createHeader, removeHeader } = useHeader();
  if (componentHeader) {
    await removeHeader();
  }
  componentHeader = createHeader({
    elementId: '__region_frame_header__',
    props: { locals: ['ja-JP', 'ko-KR', 'en', 'es-MX', 'fr-FR'] },
  });

  const { createFooter, removeFooter } = useFooter();
  if (componentFooter) {
    await removeFooter();
  }
  componentFooter = createFooter({
    elementId: '__region_frame_footer__',
    props: {
      type: type || 'large',
      theme: footerTheme,
      locals: ['ja-JP', 'ko-KR', 'en', 'es-MX', 'fr-FR'],
    },
  });
  return {
    componentHeader,
    componentFooter,
  };
}
